import React from "react";
import {recommendSearchKeywords} from "components/Layout/constants";
import classNames from "classnames/bind";
import SearchIcon from "assets/image/Layout/ObjectPanel/Search/ic_search.svg";
import DeleteIcon from "assets/image/Layout/ObjectPanel/Search/ic_delete.svg";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

function View({
  searchKeyword,
  onChange,
  handleSubmit,
  onDeleteSearchKeyword,
  onSubmitSearchKeyword,
  recentSearchKeywords,
  deleteRecentSearchKeyword,
  isDropdownOpened,
  inputBox,
  openDropdown,
  onClickDeleteBtn,
}) {
  return (
    <div className={styles.container} onClick={e => e.stopPropagation()}>
      <div
        onSubmit={handleSubmit(() => onSubmitSearchKeyword(searchKeyword))}
        className={cn("search_bar_container", isDropdownOpened && "active")}
      >
        <button onClick={() => onSubmitSearchKeyword(searchKeyword)}>
          <img src={SearchIcon} alt="search_button" />
        </button>
        <form className={styles.form} onSubmit={handleSubmit(() => onSubmitSearchKeyword(searchKeyword))}>
          <input
            onKeyDown={onDeleteSearchKeyword}
            value={searchKeyword}
            className={styles.input}
            onFocus={openDropdown}
            onChange={e => onChange(e.target.value)}
            placeholder="Search"
            ref={inputBox}
          />
        </form>
        {searchKeyword && (
          <button onClick={onClickDeleteBtn}>
            <img src={DeleteIcon} alt="delete_button" />
          </button>
        )}
      </div>
      {isDropdownOpened && (
        <div className={styles.search_bar_dropdown}>
          {!!recentSearchKeywords && recentSearchKeywords.length > 0 && (
            <div className={styles.section}>
              <div className={styles.section_header}>
                <h4 className={styles.title}>Recent</h4>
                <button className={styles.delete_button} onClick={deleteRecentSearchKeyword}>
                  Delete
                </button>
              </div>
              <div className={styles.section_content}>
                {recentSearchKeywords?.map(data => (
                  <button className={styles.item} onClick={() => onSubmitSearchKeyword(data)}>
                    <p className={styles.item_text}>{data}</p>
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className={styles.section}>
            <div className={styles.section_header}>
              <h4 className={styles.title}>Recommends</h4>
            </div>
            <div className={styles.section_content}>
              {recommendSearchKeywords?.map(data => (
                <button className={styles.item} onClick={() => onSubmitSearchKeyword(data)}>
                  <p className={styles.item_text}>{data}</p>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default View;
